import { getApiGalaxyServer } from 'services';
import { InfraRequestServicesResponse } from 'TenantModule/types';

/**
 * GET /tenant/infra-request/services (RDM-2277): whether Galaxy-initiated tenant
 * stack PRs are armed in this environment, and the connector agents the tenant
 * stack can deploy. Any logged-in Galaxy user may call it.
 */
export const getInfraRequestServicesApi = ({ token, config = {} }: BaseApiParams<void>) =>
  getApiGalaxyServer<InfraRequestServicesResponse>('/tenant/infra-request/services', config, token);
